// extracted by mini-css-extract-plugin
export default {"banner":"BottomBanner_banner__an1QX","bannerLink":"BottomBanner_bannerLink__0ZlrI"};